import "./Skills.css";
import { SKILLS } from "../../utils/data";

function Skills() {
  return (
    <section id="skills" className="homepage-section">
      <h1 className="skills-title">Tech Stack</h1>
      <div className="skills-grid">
        {SKILLS.map((group) => (
          <div key={group.category} className="skills-category">
            <h2>{group.category}</h2>
            <div className="skills-items">
              {group.items.map((skill) => (
                <span key={skill} className="skill-tag">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
